export const FLOATING_SIDEBAR_TOUR_ID = 'floating-sidebar';